import fishbowl from "../data/songs/Fishbowl.mp3"
import happy from "../data/songs/Happy.mp3"
import heroes from "../data/songs/Heroes.mp3"
import western from "../data/songs/Slow-mo Killer.mp3"
import truth from "../data/songs/Us vs. The Problem.mp3"
import watch from "../data/songs/Watch Your Back.mp3"

export const musicList = [
    {
        src: fishbowl,
        name: "Fishbowl"
    },
    {
        src: happy,
        name: "Happy"
    },
    {
        src: heroes,
        name: "Heroes"
    },
    {
        src: western,
        name: "Syd's Western"
    },
    {
        src: truth,
        name: "Truth"
    },
    {
        src: watch,
        name: "Watch Your Back"
    },
]